<svg xmlns="http://www.w3.org/2000/svg" transform="scale(1.1)" viewBox="0 0 24 24">
    <g class="layer">
        <path fill="transparent" fill-rule="evenodd" stroke="currentColor" stroke-width="1.8" d="M21.682 7.489s-.2-1.4-.8-2c-.7-.8-1.6-.8-2-.9-2.7-.2-6.9-.2-6.9-.2s-4.2 0-7 .2c-.3 0-1.2 0-2 .9-.5.6-.7 2-.7 2l-.2 3.3v1.6l.2 3.3s.2 1.4.8 2c.7.8 1.7.8 2.2.9 1.6.2 6.7.2 6.7.2s4.2 0 7-.2c.3 0 1.2 0 2-.9.5-.6.7-2 .7-2l.2-3.3v-1.6Z"/>
        <path stroke="currentColor" d="M9.882 15.489a.7.7 0 0 1-.5-1.2l2.9-3h-2.4a.7.7 0 0 1 0-1.3h4a.7.7 0 0 1 .5 1.2l-4 4a.7.7 0 0 1-.5.3m3-6.1h-2a.7.7 0 1 1 0-1.4h2a.7.7 0 0 1 0 1.4"/>
    </g>
</svg>
